import { TableRow, TableCell, Text, LabeledData } from "@jsq/ds/core";
import { addressStyle, tableCellStyle } from "./styles_vanilla.css";
import { formatAddress, AddressData } from "./utils";

interface Props {
  hasAddress: boolean;
  street?: string;
  street1?: string;
  city?: string;
  stateCode?: string | null;
  province?: string | null;
  zipcode?: string;
  country?: string;
  showAsTable?: boolean;
}

export const AddressViewOnly = ({
  hasAddress,
  street,
  street1,
  city,
  stateCode,
  province,
  zipcode,
  country,
  showAsTable = false,
}: Props) => {
  const stateCodeOrProvince = stateCode ? stateCode : province;

  const addressData: AddressData = {
    street,
    street1,
    city,
    stateCodeOrProvince,
    zipcode,
    country,
  };

  const formattedAddress = formatAddress(addressData);

  return showAsTable ? (
    <LabeledData
      className={addressStyle}
      label={"Mailing address"}
      variant={"standard"}
      value={hasAddress ? formattedAddress : "--"}
    />
  ) : (
    <TableRow>
      <TableCell className={tableCellStyle}>
        <Text color="neutral.700" variant="secondary-md">
          Physical address
        </Text>
      </TableCell>
      <TableCell className={addressStyle}>
        <Text variant="regular-md">{hasAddress ? formattedAddress : "--"}</Text>
      </TableCell>
    </TableRow>
  );
};
